import { pickBy, identity } from 'lodash';
import { httpV1 as http } from '@/services/api';

/** Envio manual imediato de notificação (push + in-app), único disparo (B2B-300/B2B-266). */

export async function create({
  emails, title, body, link,
}) {
  return http.post('/backoffice/notifications/send-by-email', pickBy({
    emails, title, body, link,
  }, identity));
}

/** Conta/lista quem receberia um disparo por perfil (role) + corretora opcional (B2B-266). */
export async function previewSegment({ role_id: roleId, promoter_id: promoterId }) {
  return http.get('/backoffice/notifications/segments/preview', {
    params: pickBy({ role_id: roleId, promoter_id: promoterId }, identity),
  });
}

export async function createBySegment({
  role_id: roleId, promoter_id: promoterId, title, body, link,
}) {
  return http.post('/backoffice/notifications/send-by-segment', pickBy({
    role_id: roleId,
    promoter_id: promoterId,
    title,
    body,
    link,
  }, identity));
}
